<template>
  <a-modal
    :body-style="modalStyle"
    :visible="visibleTenantWindow"
    title="租户搜索"
    :confirmLoading="confirmLoading"
    @ok="handleSubmit"
    @cancel="handleCancel"
    cancelText="关闭"
    wrapClassName="ant-modal-cust-warp"
    >
    <template>
    <a-row :gutter="24">
        <a-col :md="24" :sm="24" style="margin-bottom: 0px">
        <a-card :bordered="false">
            <!-- 查询区域 -->
            <div class="table-page-search-wrapper">
            <!-- 搜索区域 -->
            <a-form layout="inline" @keyup.enter.native="searchQuery">
                <a-row :gutter="24">
                <a-col :md="16" :sm="24">
                    <a-form-item label="租户名称" :labelCol="{span: 5}" :wrapperCol="{span: 18, offset: 1}">
                    <j-input placeholder="输入租户名称模糊查询" v-model="queryParam.name"></j-input>
                    </a-form-item>
                </a-col>

                <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                    <a-col :md="8" :sm="24">
                    <a-button type="primary" @click="searchQuery" icon="search" style="margin-left: 21px">查询</a-button>
                    </a-col>
                </span>
                </a-row>
            </a-form>
            </div>        

            <div style="margin-top: 5px">
            <a-table
                style="height:500px"
                ref="table"
                size="middle"
                rowKey="id"
                :columns="columns"
                :dataSource="dataSource"
                :pagination="ipagination"
                :loading="loading"
                :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange, type:'radio'}"
                @change="handleTableChange">
            </a-table>
            </div>
        </a-card>
        </a-col>    
    </a-row>
    </template>
</a-modal>
</template>
<script>
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import moment from 'moment'
  import JInput from '@comp/jeecg/JInput'

  export default {
    name: 'TenantWindow',
    mixins: [JeecgListMixin],
    components: {
      JInput,
      moment
    },
    data() {
      return {
        visibleTenantWindow: false,
        modalStyle:{
          width:'600',
          height:'400',
          overflowY: 'auto'
        },
        confirmLoading: false,
        selectedRowKeys: [],
        selectionRows:[],
        queryParam: {},
        columns:
          [
            {
              title: '租户名称',
              align: 'left',
              dataIndex: 'name'
            },
            {
              title: '联系人',
              align: 'left',
              dataIndex: 'contacts',
              width: 80,
            }
          ],
        url: {
          list: '/sys/tenant/listByUser',
        }
      }
    },
    computed: {
    },
    methods: {
      open(){
        // console.log("TenantWindow into:",this)
        this.visibleTenantWindow = true;
        this.searchQuery();
      },
      close () {
        this.$emit('close');
        this.visibleTenantWindow = false;
      },
      handleSubmit () {
        const that = this;
        that.confirmLoading = true;
        let formData = 
        {
          name:that.selectionRows[0]?that.selectionRows[0].name:"",
          id:that.selectedRowKeys[0]
        }
        console.log(formData);
        that.$emit('ok', formData);
        that.confirmLoading = false;
        this.onClearSelected();
        that.close();           
      },
      handleCancel () {
        this.onClearSelected();
        this.close()
      },
      onClearSelected() {
        this.selectedRowKeys = []
        this.selectionRows = []
        this.queryParam.name=''
      },
      onSelectChange(selectedRowKeys, selectionRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectionRows = selectionRows
        // console.log(selectionRows[0])
      },
    }
  }
</script>
<style scoped>
  /** Button按钮间距 */
  .ant-btn {
    margin-left: 8px
  }
</style>
